// Avkrysning for ekstra roller (ROLLER i src/employeeAccess.js) i skjemaene under Ansatte.
// Skjemaene vises bare for leder, så bare leder kan gi eller ta bort en rolle.
import React from 'react';
import { ROLLER } from '../employeeAccess';

export default function RolleValg({ roller = [], onChange }) {
  const veksle = (id) =>
    onChange(roller.includes(id) ? roller.filter((r) => r !== id) : [...roller, id]);

  return (
    <fieldset>
      <legend className="block text-sm font-medium text-gray-700">Ekstra roller</legend>
      <div className="mt-1 space-y-2">
        {ROLLER.map((r) => (
          <label key={r.id} className="flex items-start gap-2 text-sm text-gray-800">
            <input
              type="checkbox"
              checked={roller.includes(r.id)}
              onChange={() => veksle(r.id)}
              className="mt-0.5 h-4 w-4"
            />
            <span>
              <span className="font-medium">{r.navn}</span>
              <span className="block text-gray-600">{r.forklaring}</span>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
